"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var VALIDATIONS = {
  ALPHABETIC: 'ALPHABETIC',
  REQUIRED: 'REQUIRED',
  REQUIRED_CURRENCY: 'REQUIRED_CURRENCY',
  EMAIL: 'VALID_EMAIL',
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  PHONE: 'PHONE',
  LIST_OPTIONS: 'LIST_OPTIONS',
  EMAIL_IN_USE: 'EMAIL_IN_USE',
  COMPANY_EXIST: 'COMPANY_EXIST',
  EMAIL_IN_STRUCTURE: 'EMAIL_IN_STRUCTURE',
  DATE_IS_NOT_IN_THE_FUTURE: 'DATE_IS_NOT_IN_THE_FUTURE',
  DATE_IS_NOT_IN_THE_PAST: 'DATE_IS_NOT_IN_THE_PAST',
  DATE_IS_BETWEEN_DATES: 'DATE_IS_BETWEEN_DATES',
  DATE_IS_VALID: 'DATE_IS_VALID',
  YEAR_IS_VALID: 'YEAR_IS_VALID',
  MONTH_IS_VALID: 'MONTH_IS_VALID',
  CREDIT_CARD_IS_VALID: 'CREDIT_CARD_IS_VALID',
  IBAN_IS_VALID: 'IBAN_IS_VALID',
  BIC_IS_VALID: 'BIC_IS_VALID',
  SORT_CODE_IS_VALID: 'SORT_CODE_IS_VALID',
  URL: 'URL_IS_VALID',
  MIN_LENGTH: 'MIN_LENGTH',
  MAX_LENGTH: 'MAX_LENGTH',
  REGEX_CHECK: 'REGEX_CHECK',
  REQUIRED_SELECTION: 'REQUIRED_SELECTION'
};
var _default = VALIDATIONS;
exports.default = _default;